// extracted by mini-css-extract-plugin
export var logo = "_hp-2";
export var logoWrapper = "_hp-1";
export var strip = "_hp-0";